<template>
  <v-dialog max-width="700px">
    <v-btn slot="activator" flat color="white" class="pa-4">Sign Up</v-btn>
    <v-card>

      <v-card-title>
        <h2>Sign Up</h2>
      </v-card-title>

      <v-card-text>
        <v-form class="px-3">
          <v-text-field label="Email Address" ref="email" v-model="email" :rules="submitRules"></v-text-field>
          <v-text-field label="Password" :type="'password'" ref="password" v-model="password" :rules="submitRules"></v-text-field>
          <v-text-field label="Username" :type="'username'" ref="username" v-model="username" :rules="submitRules"></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-action> <!-- Where all the actions will go for the card: upload button and signup -->
        <v-layout align-center justify-center wrap>

          <v-flex xs3>
            <v-upload-button depressed title="User Picture" color="green lighten-3 white--text" :fileChangedCallback="fileHandler"> </v-upload-button>
          </v-flex>

          <v-flex xs3>
            <v-btn depressed class="green lighten-3 white--text" @click="submit()">Sign Up</v-btn>
          </v-flex>

          <v-flex xs12>
            <p class="text-xs-center my-1">Profile Picture is completely optional</p>
          </v-flex>

        </v-layout>
      </v-card-action>

    </v-card>
  </v-dialog>
</template>

<script>
import UploadButton from 'vuetify-upload-button';
import {bus} from '@/main.js';
import {database,auth,storage} from '@/fb.js';
const storageReference = storage.ref();
export default {
  name: 'NavBar',
  components: {
    'v-upload-button': UploadButton
  },
  data() {
      return {
        email:'',
        username: '',
        password: '',
        
        actualImage: require('@/assets/default_user.jpg'),

        submitRules: [
          value => value.length > 0 || 'Please give a input!'
        ]
      }
  },
  methods: {
      submit() { //to submit a sign up 
        if(this.$refs.email.validate() && this.$refs.password.validate() && this.$refs.username.validate()) { //Validates response, pushes image to created user storage, makes user document that stores user image reference

          auth.createUserWithEmailAndPassword(this.email,this.password).then(credit => { //gives user a creditenial token and creates the user

            const userRef = `userData/${credit.user.uid}/userImage`; //storage refernce

            storageReference.child(userRef).put(this.actualImage).then(() => { //once user created calls storage reference to push the image to user created storage

              database.collection('users').doc(credit.user.uid).set({ //after pushing the image to the users storage, adds the reference to the users document
                profilePicture: userRef,
                reports: 0,
                comments: [],
                posts: []
              })
              .then( () => { //once document created, get the downlaod url for the profile image from the storage
                console.log(userRef);
                storageReference.child(userRef).getDownloadURL().then(url => { //gets the download url

                  auth.currentUser.updateProfile({ //updates the users display name and user picture once logged in
                  displayName: this.username,
                  photoURL:url //once the download url is gotten, use it to update profile image
                  }).then(() => {
                    console.log('if you see this message, you are successful');
                  })
                
                });

              }); //fire store automatically creates 'users' collection and document
              
            });

          });

        }
      },
      fileHandler(file) {
          if(file.type === "image/png" || file.type === "image/jpeg") {
              this.actualImage = file;
          } else {
              this.acualImage = require('@/assets/user.jpg');
          }
      },
  }
}
/* 
auth.currentUser.updateProfile({ //updates the users display name and user picture once logged in
              displayName: this.username,
              photoURL: 

            }).then(() => {
              console.log(auth.currentUser);
            })
*/
</script>
